import { ENV_KEY } from '@/constants/env'

export default {
  computed: {
    shopName() {
      return this.$store.getters['auth/getShopName']
    },
    baseUrl() {
      return this.$store.getters['env/GET_KEY'](ENV_KEY.BASE_URL)
    },
  },
}
